import { IonCol } from "@ionic/react";
import { useCallback, useEffect, useState } from "react";
import FilterList, { isFilterActive } from "../../../FilterList/FilterList";
import { FilterState, NumberFilterType, StingFilterType } from "../../../FilterList/types";

import { Locale } from "../../../../setup/locale";
import List from "../../../List/List";
import { pageRange } from "../../../List/Pagination/pagerange";
import { HeaderOption } from "../../../List/types";
import { useNamedRoutes } from "../../../NamedRoutes";
import { useIsMobile } from "../../../Responsive";
import { Filter } from "../../Reports/types/reportTypes";
import { InputsSystemDocumentationProps } from "./types";


const header: HeaderOption<Locale, any>[] = [
    {
        title: '[REACT_INPUT_NO.].', key: 'inputNo', both: true
    },
    {
        title: '[REACT_FUNCTION_MODULE_TYPE]', key: 'moduleType', both: true
    },
    {
        title: '[REACT_ZONE_NUMBER]', key: 'zone', both: true
    },
    {
        title: '[REACT_ELEMENT_NUMBER]', key: 'element', breakpoint: 1200, up: true
    },
    {
        title: '[SID_DLG_TXT_TEXT1]', key: 'zoneText', breakpoint: 1200, up: true
    },
    {
        title: '[SID_DLG_TXT_TEXT2]', key: 'elementText', breakpoint: 1200, up: true
    },
    {
        title: '[REACT_ACTUATED_BY_DEVICE]', key: 'actuatedDevice', breakpoint: 1200, up: true
    },
];


type PersistentFilter = Filter<{}> & FilterState;

const ignoreKeys: (keyof PersistentFilter)[] = ["pageSize", "isFilterOpen", "page", "pageSize", "sortCriteria", "sortOrder"];


const standardFilter = {};

const InputsSystemDocumentation: React.FC<InputsSystemDocumentationProps> = ({
    system,
    filter,
    onIsOpen,
    onFilterActive
}) =>
{
    //TODO:Schauen wo das verwendet wird

    const { generate } = useNamedRoutes();
    const mobileView = useIsMobile();


    const data = [
        {
            link: generate('systems'),
            inputNo: 0,
            moduleType: "",
            zone: 0,
            element: 0,
            zoneText: "",
            elementText: "",
            actuatedDevice: "",
        },

    ];


    const [list, setList] = useState<any[] | null>(data);

    type Filter = {
        inputNo?: NumberFilterType,
        moduleType?: StingFilterType,
        zone?: NumberFilterType,
        element?: NumberFilterType,
        zoneText?: StingFilterType,
        elementText?: StingFilterType,
        actuatedDevice?: StingFilterType,
    };

    const [currentState, setState] = useState<PersistentFilter>({});

    const [clearFilterInputs, setClearFilterInputs] = useState(false);

    const [currentRowLimit, setCurrentRowLimit] = useState<number>(pageRange[1]);

    const onIsFilterOpen = useCallback((state: boolean) => { onIsOpen && onIsOpen(state, "main"); }, [onIsOpen]);
    const onIsDetailFilterOpen = useCallback((isDetailOpen: boolean) => onIsOpen && onIsOpen(isDetailOpen, "detail"), [onIsOpen]);
    const onResetFilter = useCallback(() => setState(() => standardFilter), [setState]);

    const isFilterChanged = isFilterActive<PersistentFilter>(currentState, standardFilter, ignoreKeys);

    useEffect(() =>
    {
        if (filter?.isFilterActive !== isFilterChanged) {
            onFilterActive && onFilterActive(isFilterChanged);
        }
    }, [isFilterChanged, filter, onFilterActive]);

    return <>
        <FilterList

            isOpen={filter?.isFilterOpen || false}
            isDetailsOpen={filter?.isDetailOpen || false}
            onIsOpen={onIsFilterOpen}
            onDetailOpen={onIsDetailFilterOpen}
            onReset={onResetFilter}
            noPrint
            details={<>
                <IonCol>
                    {/* <SettingsRangeInput
                        text={"TD_ID"}
                        reset={clearFilterInputs}
                        onChange={(value) =>
                        {

                            setState({
                                ...currentState, inputNo: (a: number, b: { from: number; to: number; }): boolean => numberFilter(a, value as { from: number; to: number; })
                            });

                        }} /> */}

                </IonCol>
                <IonCol></IonCol>
                <IonCol></IonCol>
                <IonCol></IonCol>
                <IonCol></IonCol>
            </>}
        >
        </FilterList >



        <List
            rows={list}
            maxHeight={mobileView ? '86vh' : "48vh"}
            headers={header}

        />
    </>;
};

export default InputsSystemDocumentation;
